import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { EveCredentialsInputDTORuntype, EveResponseBodyDTORuntype } from './eveBackendTypes';

export const eveEndpoints = {
    'GET /3rdparty/eve/credentials': endpoint({
        description: 'Returns credentials for eve integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: EveResponseBodyDTORuntype,
    }),
    'POST /3rdparty/eve/credentials': endpoint({
        description: 'Uploads credentials for eve API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: EveCredentialsInputDTORuntype,
        responseBody: EveResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/eve/credentials'],
    }),
    'PATCH /3rdparty/eve/credentials': endpoint({
        description: 'Updates credentials for eve API integratoin',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: EveCredentialsInputDTORuntype,
        responseBody: EveResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/eve/credentials'],
    }),
    'DELETE /3rdparty/eve/credentials': endpoint({
        description: 'Deletes existing credentials for eve API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/eve/credentials'],
    }),
};
